"use strict";
/// <reference path="Menu.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
require("@progress/kendo-ui");
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
const CommandLayout_1 = require("./CommandLayout");
const MethodManager_1 = require("./MethodManager");
class Menu {
    static init($elem, options, commandLayouts, commandTriggerTarget) {
        return $elem.each(function () {
            const $this = $(this);
            let synData = $this.data('synMenu');
            if (!synData) { // the plugin hasn't been initialized yet
                $this.data('synMenu', $.extend({
                    iconWsUrl: Utilities_1.synUtil.getWSUrl("Icon"),
                    data: [],
                    raiseBeforeExecuteMethod: false,
                    viewId: 'default',
                    renderMode: Utilities_1.synUtil.clientDeviceClass === "phone" ? "compact" : "full",
                    orientation: Utilities_1.synUtil.clientDeviceClass === "phone" ? "vertical" : "horizontal",
                    direction: Utilities_1.synUtil.clientDeviceClass === "phone" ? "bottom bottom bottom" : "default",
                    iconSize: 32,
                    commandLayouts
                }, options));
                synData = $this.data('synMenu');
                $this.trigger("beginInit");
                $this.addClass("synMenu");
                $this.addClass("tdWebControl");
                if (Utilities_1.synUtil.isHDScreen) {
                    $this.addClass('HDScreen');
                    synData.iconSize = 64;
                }
                synData.iconSize = 32;
                kendo.ui.Tooltip.fn._mouseleave = function (e) {
                    clearTimeout(this.timeout);
                };
                CommandLayout_1.CommandLayoutsType.AddTooltip($this);
                let menuDataSource = commandLayouts.GetDataSource(CommandLayout_1.MenuType.ToolBar);
                $this.trigger("beginFetchMenuLayout");
                $this.append("<li class='waitElem'><i class='fa fa-spinner tdWaitSpinner'></i><span class='waitText'>"
                    + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("synwait"))
                    + "</span></li>");
                menuDataSource.fetch(function () {
                    $this.html("").kendoMenu({
                        dataSource: this._pristineData,
                        animation: false,
                        openOnClick: {
                            rootMenuItems: true,
                            subMenuItems: false
                        },
                        orientation: synData.orientation,
                        direction: synData.direction,
                        activate(e) {
                            if ($this.data("kendoTooltip")) {
                                $this.data("kendoTooltip").hide();
                                clearTimeout($this.data("kendoTooltip").timeout);
                            }
                        },
                        close(e) {
                            if ($this.data("kendoTooltip"))
                                synData.noTooltip = false;
                        },
                        select(e) {
                            let item = $(e.item);
                            let menuEntry = Menu.getDataItem($elem, $(item));
                            let commandLayouts = synData.commandLayouts;
                            if (menuEntry)
                                MethodManager_1.MethodManager.executeMethodForMenu(menuEntry, commandLayouts, $this, commandTriggerTarget);
                        }
                    });
                    // After updating to kendoUI 2020.3.1118, submenus are loaded lazily by default. This prevents us
                    // from correctly assigning the initial enabled/disabled state of the child menu items, so we have 
                    // to load the submenus explicitly
                    const childNodes = $this.data("kendoMenu").dataSource.data().filter((item) => item.hasChildren);
                    childNodes
                        .forEach(d => d.load());
                    for (let i in childNodes)
                        childNodes[i]["items"].filter((item) => item.hasChildren)
                            .forEach(d => d.load());
                    $this.children("li").each((_idx, li) => {
                        $(li).find(".k-item.separator").each((_idx, elem) => {
                            $(elem).html("").append("<hr/>");
                        });
                    });
                    // Initially enable/disable all menuentries based on selcount etc
                    Menu.enable($this, true);
                    if ("compact" === synData.renderMode)
                        $this.children("li.k-item").children("span.k-link").children("span.k-icon").remove();
                    $this.trigger("initSuccess");
                    $this.trigger("endInit");
                });
            }
        });
    }
    static getDataItem($elem, domItem) {
        const menuElement = domItem.closest(".k-menu");
        let dataItem = $elem.data("kendoMenu").options.dataSource;
        let index = domItem.parentsUntil(menuElement, ".k-item").map(function () {
            return $(this).index();
        }).get().reverse();
        index.push(domItem.index());
        for (let i = -1, len = index.length; ++i < len;) {
            dataItem = dataItem[index[i]];
            dataItem = i < len - 1 ? dataItem.items : dataItem;
        }
        return dataItem;
    }
    static enable($elem, enable) {
        const synData = $elem.data("synMenu");
        if (synData) {
            if (enable)
                Menu.revalidate($elem);
            else {
                $elem.find(".k-item:not(:has(.k-group))").each(function (idx, elem) {
                    $elem.data("kendoMenu").enable($(elem), false);
                });
            }
        }
    }
    static revalidate($elem) {
        if ($elem.data("synMenu")) {
            const kendoMenu = $elem.data("kendoMenu");
            $elem.find(".k-item:not(:has(.k-group))").each((_idx, elem) => {
                const $target = $(elem);
                if (!$target.hasClass('separator')) {
                    const synData = $elem.data('synMenu');
                    const menuItem = Menu.getDataItem($elem, $target);
                    const selectionContext = synData.commandLayouts.SelectionContext.FullSelectionContext;
                    const bActive = CommandLayout_1.CommandLayoutsType.IsMethodAllowed(menuItem, selectionContext);
                    kendoMenu.enable($target, bActive);
                }
            });
            $elem.find(".k-item:has(.k-group)").each((_idx, elem) => {
                const $groupItem = $(elem);
                kendoMenu.enable($groupItem, $groupItem.find(".k-item").length > $groupItem.find(".k-item.k-state-disabled").length);
            });
        }
    }
    static closeMenu($elem) {
        return $elem.each(function () {
            $elem.find("> .k-item").each(function (idx, elem) {
                const $target = $(elem);
                $elem.data("kendoMenu").close($target);
            });
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            if ($elem.data("kendoMenu"))
                $elem.data("kendoMenu").destroy();
            $elem.removeData('synMenu');
            $(this).off("beginInit");
            $(this).off("initSuccess");
            $(this).off("endInit");
        });
    }
}
exports.Menu = Menu;
// Dispatcher code
(($) => {
    $.fn.synMenu = function (method) {
        if (Menu[method])
            return Menu[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Menu.init(this, arguments[0], arguments[1], arguments[2]);
        else
            $.error("Method " + method + " does not exist on jQuery.synMenu");
    };
})(jQuery);
